import Navbar from "../components/Navbar";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import { AiFillPhone } from "react-icons/ai";
import Footer from "../components/Footer";
import HeroVenue from "../components/Hero_venue";
import heroImage from "../assets/RsjcLogo.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import Canonical from "../components/canonical";
export function Contact() {
  // export const ContactUs = () => {
  const form = useRef();
  const [success, setSuccess] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);

  const onChange = (token) => {
    setCaptchaToken(token);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert("Complete the captcha");
      return;
    }

    emailjs
      .sendForm("service_ppmggc1", "template_6oyxi1k", form.current, {
        publicKey: "ok0MluiSrAIPcqWb6",
      })
      .then(() => {
        setSuccess(true);
        form.current.reset();
        setCaptchaToken(null);

        setTimeout(() => setSuccess(false), 4000);
      })
      .catch((error) => {
        console.log("FAILED...", error.text);
      });
  };

  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <HeroVenue imageSrc={heroImage} heroAreaName={"Contact"} />
      <div className=" bg-[#01184D] text-white w-full text-center flex flex-col items-center justify-center ">
        <div className="my-8">
          <h1 className="uppercase md:text-4xl text-xl sm:text-2xl pb-8">
            Contact Us
          </h1>
          <p className="mx-6 md:text-xl sm:text-lg text-sm pb-4">
            Use the Contact Form below to send us a message or use our contact
            details to contact us directly
          </p>
        </div>
      </div>
      <div className="bg-[#075AAA] text-[#ffffff]">
        <div className="mx-auto max-w-[1248px] w-full grid md:grid-cols-2 h-auto px-4">
          <div className=" justify-center">
            <h1 className="md:text-4xl text-xl sm:text-2xl my-4 font-bold">
              Contact
            </h1>
            <div className="flex flex-wrap pb-4 ">
              <AiFillPhone size={50} />
              <span className="pl-6 md:text-xl sm:text-lg text-sm my-4 ">
                07711 164168
              </span>
            </div>
            {/* <div className="flex flex-wrap pb-4">
              <AiOutlineMail size={50} />
              <span className="pl-6 md:text-xl sm:text-lg text-sm my-4 ">
                EMAIL ADDRESS TO GO HERE!
              </span>
            </div> */}
            <div className="md:text-4xl text-xl sm:text-2xl my-4">
              <h1 className="font-bold">Address</h1>
              <p className=" md:text-xl sm:text-lg text-sm my-4 mb-4">
                <span className="font-bold">Tuesday</span>
                <br />
                Wick Hall
                <br />
                76 Wick Street
                <br />
                Littlehampton 7JS
                <br />
                BN17 7JS <br />
              </p>
              <p className=" md:text-xl sm:text-lg text-sm my-4 mb-4">
                <span className="font-bold">Wednesday</span>
                <br />
                The Ashington Centre
                <br />
                Foster Lane
                <br />
                Ashington
                <br />
                West Sussex
                <br />
                RH20 3PG
                <br />
              </p>
              <p className=" md:text-xl sm:text-lg text-sm my-4 mb-4">
                <span className="font-bold">Friday</span> <br />
                Worthing Leisure Centre, Main Hall
                <br />
                Shaftsbury Avenue
                <br />
                Worthing
                <br />
                Sussex
                <br />
                BN12 4ET
                <br />
              </p>
            </div>
          </div>
          <div className="justify-center">
            <h1 className="md:text-4xl text-xl sm:text-2xl my-4 font-bold">
              Send a Message
            </h1>
            {/* <form onSubmit={handleSubmit}></form> */}

            <form ref={form} onSubmit={sendEmail}>
              <div>
                <label form="">Your Name</label>
              </div>
              <div className="py-2 text-black">
                <input
                  name="name"
                  required="true"
                  id="name"
                  className="w-full"
                  type="text"
                  placeholder="Your Name"
                  // onChange={handleChange}
                ></input>
              </div>
              <div>
                <label form="">Email Address</label>
              </div>
              <div className="py-2 text-black">
                <input
                  className="w-full"
                  type="email"
                  required="true"
                  id="email"
                  placeholder="Email Address"
                  name="email"
                  // onChange={handleChange}
                ></input>
              </div>
              <div>
                <label form="">Phone Number</label>
              </div>
              <div className="py-2 text-black">
                <input
                  className="w-full"
                  type="number"
                  placeholder="Phone Number"
                  name="phone"
                  required="true"
                  id="phone"
                  // onChange={handleChange}
                ></input>
              </div>
              <div>
                <label form="">Message</label>
              </div>
              <div className="py-2 text-black">
                <textarea
                  rows={5}
                  className="w-full"
                  type="number"
                  id="message"
                  name="message"
                  placeholder="Your Message"
                  // onChange={handleChange}
                ></textarea>
                {/* Add reCAPTCHA widget */}
                <input
                  type="hidden"
                  name="g-recaptcha-response"
                  value={captchaToken || ""}
                />
                <ReCAPTCHA
                  className="mt-4"
                  sitekey="6LcZSR0rAAAAAOyzCIGh0z6AkfRl-DQ0wMTRoPXl" // Replace with your Site Key
                  onChange={onChange}
                />
              </div>
              <p className="md:text-lg text-sm sm:text-baseline">
                By sending a message you are agreeing to this website{" "}
                <Link to="/privacy">
                  <span className="font-bold underline">Privacy Policy</span>
                </Link>
              </p>
              <button
                className="px-4 py-2 my-4 bg-white text-[#075AAA] font-bold"
                type="submit"
              >
                Send Message
              </button>
            </form>
            {success && (
              <div className="bg-green-500 text-white md:text-lg text-sm sm:text-baseline px-4 py-3 mb-4 rounded animate-fade">
                Message sent, we will be in contact soon
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
